import React from 'react';

import { observer } from 'mobx-react';
import { TitledInfo } from '../../../../../../shared/components/ui-components';
import { PriceInfo } from '../../../../../components/PriceInfo/PriceInfo';
import { currentSubscriptionPlanStore } from '../../../../../stores/currentSubscriptionPlanStore';
import { getIsNonPaidSubscription } from '../../../../../utils/getIsNonPaidSubscription/getIsNonPaidSubscription';

const AutoRenewInfo = observer(() => {
  const { currentSubscriptionPlan, subscriptionTypeFlags, paymentStatusFlag } =
    currentSubscriptionPlanStore;

  if (!currentSubscriptionPlan) {
    return null;
  }

  const { subscription, explorePlan } = currentSubscriptionPlan;

  const subscriptionToShow = subscription || explorePlan;

  const isNonPaidSubscription = getIsNonPaidSubscription(
    subscriptionToShow?.subscriptionType,
  );

  return (
    <TitledInfo title="Auto Renew">
      <PriceInfo
        price={subscriptionToShow?.monthlyRenewalPrice}
        finalPrice={subscriptionToShow?.monthlyRenewalPriceFinal}
        duration="per month"
        hidePrice={isNonPaidSubscription}
        hiddenPricePlaceholder={
          subscriptionTypeFlags.SELF_BILLING && !paymentStatusFlag.CANCELED
            ? 'Billed by the entity'
            : '—'
        }
      />
    </TitledInfo>
  );
});

export { AutoRenewInfo };
